import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageDemo/upload.vue'
createPage(Page)